import { Button, Layout, theme, Form, Select, Input, Spin, notification } from "antd";

import React, { useEffect, useState, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import StorageInstructionsApi from "../../common/Apis/StorageInstructionsApi";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import StorageListApi from "../../common/Apis/StorageListApi";
import DepartmentDropdown from "../../common/DropDowns/Department";

const AddStorageInstructions = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [Sensors, setSensors] = React.useState([]);
  const getSensores = useCallback(() => {
    StorageListApi.ListStorage()
      .then((response) => {
        console.log(response);
        setSensors(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  useEffect(() => {
    getSensores();
  }, [getSensores]);

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      instruction: data?.instruction,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: data?.institutionId,
      },
      storageDTO: {
        id: data?.StorageID,
      },
    })

    StorageInstructionsApi.CreateStorageInstructions(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/storage-instructions");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>  <Col lg={12} md={12}>
                <Form.Item
                  name="instruction"
                  label="Instruction"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Instruction",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Instruction"
                    className="control-input"
                  />
                </Form.Item>
              </Col></Row>
              <Row gutter={16}>

                <Col lg={10} md={12}>
                  <DepartmentDropdown />
                </Col>
                <Col lg={10} md={12}>
                  <Form.Item
                    name="StorageID"
                    label="Storage *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Storage.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Storage"
                    >
                      {Sensors && (
                        <>
                          {Sensors?.map((option, index) => (
                            <option key={index} value={option?.id}>
                              {option?.name}
                            </option>
                          ))}
                        </>
                      )}
                    </Select>
                  </Form.Item>
                </Col>

              </Row>

              {/* <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div> */}
              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                >
                  Create {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout >
  );
};
export default AddStorageInstructions;
